import { render, staticRenderFns } from "./realEstateImageSwiper.vue?vue&type=template&id=45ed6b1e&"
import script from "./realEstateImageSwiper.vue?vue&type=script&lang=js&"
export * from "./realEstateImageSwiper.vue?vue&type=script&lang=js&"
import style0 from "./realEstateImageSwiper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports